import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertifyService, Note, NoteType, Project, Tags } from 'core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NotesService } from 'projects/core/src/services/note.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-vendor-screening-criteria',
  templateUrl: './vendor-screening-criteria.component.html',
  styleUrls: ['./vendor-screening-criteria.component.scss']
})
export class VendorScreeningCriteriaComponent implements OnInit {

  note: Note;

  editorConfig = {
    startupFocus: true,
    language: 'en',
    placeholder: "Type body and click save",
    toolbar: {
      items: [
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList'
      ],
      
    }
  };
  
  @Input() project = {} as Project;
  @Input() screeningCriteria: Note;
  @Output() saveNoteEvent = new EventEmitter<Note>();

  constructor(
    public bsModalRef: BsModalRef,
    private noteService: NotesService,
    private alertify: AlertifyService,
  ) { }

  ngOnInit() {
    this.note = this.screeningCriteria || { message: '', noteType: NoteType.ScreeningCriteria } as Note;
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  save() {
    if (this.note.message.trim() === '') {
      this.alertify.error('Please write a note.');
      return;
    }
    
    if( this.note.id) {
      this.updateNote();
    }
    else {
      this.saveNote();
    }
  }


  saveNote() {
    this.note.id =  uuidv4();
    this.note.projectId = this.project.id;
    
    this.noteService.addNote(this.note).subscribe(() => {
      this.alertify.success('Note added successfully');
      this.saveNoteEvent.emit(this.note);
      this.bsModalRef.hide();
    }, error => console.error(error));
  }

  updateNote() {
    this.noteService.editNote(this.note).subscribe(() => {
      this.alertify.success('Note updated successfully');
      this.bsModalRef.hide();
    }, error => {
      console.error(error);
      this.alertify.error('Failed to update note');
    });
  }
  

  cancel() {
    this.bsModalRef.hide();
  }

  wysiwygUpdate(event) { 
    this.note.message = event;
  }
}
